var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lib-faq" },
    [
      _c("h2", [_vm._v("Frequently Asked Questions")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "categories" },
        _vm._l(_vm.faq, function (category, categoryIndex) {
          return _c(
            "button",
            {
              class: { active: categoryIndex === _vm.openCategoryIndex },
              on: {
                click: function ($event) {
                  return _vm.categoryClicked(categoryIndex)
                },
              },
            },
            [_vm._v(_vm._s(category.name))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._l(_vm.faq, function (category, categoryIndex) {
        return categoryIndex === _vm.openCategoryIndex
          ? _c(
              "div",
              { staticClass: "category" },
              _vm._l(category.questions, function (question, index) {
                return _c("div", { staticClass: "question-answer" }, [
                  _c(
                    "div",
                    {
                      staticClass: "question",
                      on: {
                        click: function ($event) {
                          return _vm.questionClicked(index)
                        },
                      },
                    },
                    [
                      _c("h3", [_vm._v(_vm._s(question.question))]),
                      _vm._v(" "),
                      _vm._m(0, true),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.openQuestionIndex === index
                    ? _c(
                        "div",
                        { staticClass: "answer" },
                        _vm._l(question.answer, function (paragraph) {
                          return _c("p", {
                            domProps: { innerHTML: _vm._s(paragraph) },
                          })
                        }),
                        0
                      )
                    : _vm._e(),
                ])
              }),
              0
            )
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", [_c("i", { staticClass: "fa fa-plus" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }